import * as React from "react";

import primaryColour from "../../constants";

function SvgHarshCornerleft(props: React.SVGProps<SVGSVGElement>) {
  const { fill = primaryColour } = props;
  return (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.1179 21.4426L17.4131 14.2265C19.0648 11.4516 17.0253 8.02141 13.8507 8.00007L13.8407 8V8.00003L8.24756 8.00004V5L3.25075 9.47559L8.24756 13.7835V11L13.8347 11C14.7656 11.0091 15.2613 11.9762 14.8352 12.692L9.74223 21.2485C10.4678 21.4159 11.2236 21.5044 12 21.5044C12.3779 21.5044 12.7509 21.4834 13.1179 21.4426Z"
        fill={fill}
      />
    </svg>
  );
}

export default SvgHarshCornerleft;
